import React from 'react';
import { CtaButton } from './CtaButton';
import { offer } from '../data/offer';
interface OfferBlockProps {
  className?: string;
  id?: string;
}

/** Price + buy button + the two small clarification lines. Reused wherever the
 * decision moment appears on the page. */
export function OfferBlock({
  className = '',
  id
}: OfferBlockProps) {
  return <div id={id} className={`scroll-mt-6 text-center ${className}`} data-id="element-129" data-mp="4x2z3a17vsk0">
      <div className="flex flex-wrap items-baseline justify-center gap-x-4 gap-y-2" data-id="element-130" data-mp="slum7mzy9kpx">
        <span className="font-display text-5xl font-extrabold tabular-nums text-white" data-id="element-131" data-mp="wmelaw432yep">
          {offer.priceToday}
        </span>
        <span className="text-xl text-white/40 line-through" data-id="element-132" data-mp="iuhtyua8osjd">{offer.priceTomorrow}</span>
        <span className="text-sm text-celeste-300" data-id="element-133" data-mp="ns9vmg0ort0r">
          একবারের পেমেন্ট · ৬টি ভলিউম + ৫টি বোনাস · লাইফটাইম অ্যাক্সেস — ১০০% সিকিউর চেকআউট — সাথে সাথেই ডিজিটাল ডাউনলোড
        </span>
      </div>

      <div className="mt-8 flex flex-col items-center" data-id="element-134" data-mp="1gboxi04mf182">
        <CtaButton size="lg" href={offer.checkoutUrl} note="ইবুকগুলো ইংরেজি ভাষায় লেখা" label={<>হ্যাঁ! আমি দ্য আর্জেন্টাইন মাইন্ডসেট চাই 🏆 মাত্র <span className="text-[1.35em] font-extrabold" data-id="element-136" data-mp="2vmeig02oafdd">9</span> USD-তে (প্রায় 1,050 BDT)</>} sublabel={`সাথে সাথেই অ্যাক্সেস · ৭ দিনের গ্যারান্টি · ${offer.studentCount} শিক্ষার্থীর সাথে যোগ দিন`} data-id="element-135" data-mp="2zlx26sirckem" />
      </div>
    </div>;
}